export default __webpack_public_path__ + "static/media/miscellaneous12.e6b70216.png";